<template>
    <span
        class="chat-avatar"
        aria-hidden="true"
        >M</span
    >
</template>

<style scoped lang="scss">
    @import '../../../sass/globals';

    .chat-avatar {
        display: inline-flex;
        flex: 0 0 var(--chat-avatar, 30px);
        align-items: center;
        justify-content: center;
        width: var(--chat-avatar, 30px);
        height: var(--chat-avatar, 30px);
        border-radius: 50%;
        color: $black;
        background: $yellow;
        font-size: 15px;
        font-weight: 700;
        line-height: 1;
    }
</style>
